import type Lenis from "lenis";

/** Wysokość sticky-nav — zgodna ze `scroll-margin-top` z index.css. */
export const SCROLL_OFFSET = 112;

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

type ScrollOptions = {
  lenis?: Lenis | null;
  /** Wymuszenie braku animacji (np. gdy użytkownik ogranicza ruch). */
  reducedMotion?: boolean;
  offset?: number;
};

/** Płynne przewinięcie do elementu (sekcja / tytuł podstrony). */
export function scrollToElement(target: Element, options: ScrollOptions = {}) {
  const reduced = options.reducedMotion ?? prefersReducedMotion();
  const offset = options.offset ?? -SCROLL_OFFSET;

  if (!reduced && options.lenis) {
    options.lenis.scrollTo(target as HTMLElement, { offset });
    return;
  }

  if (reduced) {
    const top = target.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, left: 0, behavior: "auto" });
    return;
  }

  target.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** Płynny (lub natychmiastowy przy reduced motion) powrót na górę strony. */
export function scrollToTop(options: ScrollOptions = {}) {
  const reduced = options.reducedMotion ?? prefersReducedMotion();

  if (!reduced && options.lenis) {
    options.lenis.scrollTo(0, { immediate: false });
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: reduced ? "auto" : "smooth" });
}
